import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import {
  FaHome,
  FaCalendarAlt,
  FaBook,
  FaGraduationCap,
  FaUsers,
  FaSchool,
  FaStar,
  FaFlag,
  FaTrophy,
  FaCertificate,
  FaBookOpen,
  FaChalkboardTeacher,
  FaMicroscope,
  FaMusic,
  FaFutbol,
  FaTree,
  FaSun,
  FaFilter,
  FaChevronLeft,
  FaChevronRight,
  FaSearch
} from "react-icons/fa";
import BreadCrumbImage from "../assets/images/breadcrumb.png";

const Calendar = () => {
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedType, setSelectedType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const monthsData = [
    {
      id: "jan",
      name: "January",
      short: "Jan",
      events: [
        { date: "1", title: "New Year's Day", type: "holiday", icon: FaFlag },
        { date: "14", title: "Makar Sankranti", type: "holiday", icon: FaSun },
        { date: "15", title: "Pongal", type: "holiday", icon: FaSun },
        { date: "26", title: "Republic Day", type: "holiday", icon: FaFlag },
        { date: "27", title: "School Reopens", type: "academic", icon: FaSchool },
        { date: "28-31", title: "Orientation", type: "event", icon: FaUsers }
      ]
    },
    {
      id: "feb",
      name: "February",
      short: "Feb",
      events: [
        { date: "5", title: "Vasant Panchami", type: "holiday", icon: FaTree },
        { date: "14", title: "Mid-Term Exams", type: "academic", icon: FaBook },
        { date: "16-20", title: "Science Exhibition", type: "event", icon: FaMicroscope },
        { date: "25", title: "Exams End", type: "academic", icon: FaBook },
        { date: "26", title: "Results", type: "academic", icon: FaCertificate }
      ]
    },
    {
      id: "mar",
      name: "March",
      short: "Mar",
      events: [
        { date: "8", title: "Holi", type: "holiday", icon: FaTree },
        { date: "10", title: "Sports Day", type: "event", icon: FaFutbol },
        { date: "17", title: "PT Meeting", type: "event", icon: FaUsers },
        { date: "25", title: "Annual Day Prep", type: "event", icon: FaMusic },
        { date: "30", title: "Summer Break", type: "holiday", icon: FaSun }
      ]
    },
    {
      id: "apr",
      name: "April",
      short: "Apr",
      events: [
        { date: "2", title: "Good Friday", type: "holiday", icon: FaTree },
        { date: "14", title: "Ambedkar Jayanti", type: "holiday", icon: FaFlag },
        { date: "15", title: "Bohag Bihu", type: "holiday", icon: FaTree },
        { date: "21", title: "Summer Camp", type: "event", icon: FaSun },
        { date: "30", title: "Camp Ends", type: "event", icon: FaSun }
      ]
    },
    {
      id: "may",
      name: "May",
      short: "May",
      events: [
        { date: "1", title: "Labour Day", type: "holiday", icon: FaFlag },
        { date: "5", title: "Buddha Purnima", type: "holiday", icon: FaTree },
        { date: "20", title: "School Reopens", type: "academic", icon: FaSchool },
        { date: "25-30", title: "Unit Test I", type: "academic", icon: FaBook }
      ]
    },
    {
      id: "jun",
      name: "June",
      short: "Jun",
      events: [
        { date: "5", title: "Environment Day", type: "event", icon: FaTree },
        { date: "21", title: "Yoga Day", type: "event", icon: FaSun },
        { date: "25-30", title: "Project Week", type: "academic", icon: FaBookOpen },
        { date: "30", title: "PTA Meeting", type: "event", icon: FaUsers }
      ]
    },
    {
      id: "jul",
      name: "July",
      short: "Jul",
      events: [
        { date: "17", title: "Bakrid", type: "holiday", icon: FaTree },
        { date: "20-25", title: "Mid-Year Exams", type: "academic", icon: FaBook },
        { date: "27", title: "Guru Purnima", type: "event", icon: FaChalkboardTeacher },
        { date: "30", title: "Results", type: "academic", icon: FaCertificate }
      ]
    },
    {
      id: "aug",
      name: "August",
      short: "Aug",
      events: [
        { date: "15", title: "Independence Day", type: "holiday", icon: FaFlag },
        { date: "19", title: "Janmashtami", type: "holiday", icon: FaTree },
        { date: "20-25", title: "Inter-School Comp", type: "event", icon: FaTrophy },
        { date: "30", title: "Rakhi Celebration", type: "event", icon: FaStar }
      ]
    },
    {
      id: "sep",
      name: "September",
      short: "Sep",
      events: [
        { date: "5", title: "Teacher's Day", type: "event", icon: FaChalkboardTeacher },
        { date: "10", title: "Ganesh Chaturthi", type: "holiday", icon: FaTree },
        { date: "15-20", title: "Unit Test II", type: "academic", icon: FaBook },
        { date: "25", title: "Break Begins", type: "holiday", icon: FaSun }
      ]
    },
    {
      id: "oct",
      name: "October",
      short: "Oct",
      events: [
        { date: "2", title: "Gandhi Jayanti", type: "holiday", icon: FaFlag },
        { date: "8", title: "Dussehra", type: "holiday", icon: FaTree },
        { date: "12", title: "School Reopens", type: "academic", icon: FaSchool },
        { date: "20", title: "Diwali Break", type: "holiday", icon: FaStar },
        { date: "24", title: "Diwali", type: "holiday", icon: FaStar },
        { date: "29", title: "School Reopens", type: "academic", icon: FaSchool }
      ]
    },
    {
      id: "nov",
      name: "November",
      short: "Nov",
      events: [
        { date: "1", title: "Annual Prep", type: "academic", icon: FaBook },
        { date: "14", title: "Children's Day", type: "event", icon: FaUsers },
        { date: "20-25", title: "Pre-Boards", type: "academic", icon: FaGraduationCap },
        { date: "30", title: "Last Day", type: "academic", icon: FaSchool }
      ]
    },
    {
      id: "dec",
      name: "December",
      short: "Dec",
      events: [
        { date: "1-15", title: "Annual Exams", type: "academic", icon: FaBook },
        { date: "18", title: "Results", type: "academic", icon: FaCertificate },
        { date: "20", title: "Prize Day", type: "event", icon: FaTrophy },
        { date: "22", title: "Winter Break", type: "holiday", icon: FaSun },
        { date: "25", title: "Christmas", type: "holiday", icon: FaTree }
      ]
    }
  ];

  const eventTypes = {
    all: { label: "All Events", color: "bg-gray-100 text-gray-800" },
    holiday: { label: "Holidays", color: "bg-red-100 text-red-800" },
    academic: { label: "Academic", color: "bg-blue-100 text-blue-800" },
    event: { label: "Events", color: "bg-green-100 text-green-800" }
  };

  const importantDates = [
    { title: "Academic Year Begins", date: "Jan 27, 2026", type: "academic" },
    { title: "Summer Vacation", date: "Mar 30 - May 19", type: "holiday" },
    { title: "Diwali Break", date: "Oct 20 - 28", type: "holiday" },
    { title: "Annual Exams", date: "Dec 1-15", type: "academic" },
    { title: "Winter Vacation", date: "Dec 22 - Jan 26", type: "holiday" },
    { title: "School Timing", date: "8:30 AM - 2:30 PM", type: "info" }
  ];

  // Filter months
  const filteredMonths = monthsData.filter(month => 
    selectedMonth === "all" || month.id === selectedMonth
  ).map(month => ({
    ...month,
    events: month.events.filter(event => 
      (selectedType === "all" || event.type === selectedType) &&
      (searchTerm === "" || 
        event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.type.toLowerCase().includes(searchTerm.toLowerCase()))
    )
  })).filter(month => month.events.length > 0);

  return (
    <Layout>
      <Helmet>
        <title>Academic Calendar 2026 | School</title>
        <meta name="description" content="Complete academic calendar 2026 with holidays, exams, and events. Filter by month and event type." />
      </Helmet>

      {/* Breadcrumb */}
      <div className="relative bg-gray-900">
        <div className="h-40 md:h-48">
          <img src={BreadCrumbImage} alt="Breadcrumb" className="object-cover w-full h-full opacity-60" />
          <div className="absolute inset-0 bg-black/50" />
        </div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-2 text-xs text-white">
            <Link to="/" className="flex items-center transition-colors hover:text-gray-200">
              <FaHome className="w-3 h-3 mr-1" />
              Home
            </Link>
            <span className="mx-1">/</span>
            <span className="font-semibold">Calendar</span>
          </div>
          <h1 className="text-2xl font-bold text-white md:text-3xl">Academic Calendar 2026</h1>
          <p className="mt-1 text-xs text-gray-300">Complete yearly schedule</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container px-3 py-6 mx-auto md:px-4 md:py-8">
        
        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-3 mb-6 md:grid-cols-6">
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-gray-900 md:text-xl">12</div>
            <div className="text-xs text-gray-600">Months</div>
          </div>
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-red-600 md:text-xl">24</div>
            <div className="text-xs text-gray-600">Holidays</div>
          </div>
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-blue-600 md:text-xl">18</div>
            <div className="text-xs text-gray-600">Exams</div>
          </div>
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-green-600 md:text-xl">15</div>
            <div className="text-xs text-gray-600">Events</div>
          </div>
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-purple-600 md:text-xl">3</div>
            <div className="text-xs text-gray-600">Terms</div>
          </div>
          <div className="p-3 text-center bg-white border border-gray-200 rounded-lg">
            <div className="text-lg font-bold text-amber-600 md:text-xl">57</div>
            <div className="text-xs text-gray-600">Total Days</div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="p-4 mb-6 bg-white border border-gray-200 rounded-xl">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            {/* Search */}
            <div className="relative flex-1">
              <FaSearch className="absolute w-4 h-4 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
              <input
                type="text"
                placeholder="Search events..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full py-2 pl-10 pr-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Month Filter */}
            <div className="flex items-center gap-2">
              <FaFilter className="w-4 h-4 text-gray-600" />
              <select 
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="all">All Months</option>
                {monthsData.map(month => (
                  <option key={month.id} value={month.id}>{month.name}</option>
                ))}
              </select>
            </div>

            {/* Type Filter - Tabs */}
            <div className="flex flex-wrap gap-2">
              {Object.entries(eventTypes).map(([key, value]) => (
                <button
                  key={key}
                  onClick={() => setSelectedType(key)}
                  className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                    selectedType === key 
                      ? `${value.color} border` 
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {value.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Month Navigation */}
        <div className="mb-6 overflow-x-auto">
          <div className="flex pb-2 space-x-2">
            <button
              onClick={() => setSelectedMonth("all")}
              className={`px-4 py-2 text-sm font-medium rounded-lg whitespace-nowrap ${
                selectedMonth === "all" 
                  ? "bg-blue-600 text-white" 
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              All Months
            </button>
            {monthsData.map(month => (
              <button
                key={month.id}
                onClick={() => setSelectedMonth(month.id)}
                className={`px-4 py-2 text-sm font-medium rounded-lg whitespace-nowrap ${
                  selectedMonth === month.id 
                    ? "bg-blue-600 text-white" 
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {month.short}
              </button>
            ))}
          </div>
        </div>

        {/* Calendar Grid */}
        {filteredMonths.length === 0 ? (
          <div className="p-8 text-center bg-white border border-gray-200 rounded-xl">
            <FaCalendarAlt className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p className="text-gray-600">No events found for the selected filters.</p>
            <button 
              onClick={() => {setSelectedMonth("all"); setSelectedType("all"); setSearchTerm("");}}
              className="px-4 py-2 mt-3 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {filteredMonths.map(month => (
              <div key={month.id} className="overflow-hidden transition-shadow bg-white border border-gray-200 shadow-sm rounded-xl hover:shadow-md">
                {/* Month Header */}
                <div className="p-4 border-b border-blue-200 bg-gradient-to-r from-blue-50 to-blue-100">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold text-gray-900">{month.name} 2026</h3>
                    <span className="px-2 py-1 text-xs font-medium text-blue-700 bg-white rounded-lg">
                      {month.events.length} events
                    </span>
                  </div>
                </div>
                
                {/* Events List */}
                <div className="p-4">
                  <div className="space-y-3">
                    {month.events.map((event, index) => (
                      <div 
                        key={index}
                        className={`flex items-start gap-3 p-3 rounded-lg border ${
                          event.type === 'holiday' ? 'bg-red-50 border-red-200' :
                          event.type === 'academic' ? 'bg-blue-50 border-blue-200' :
                          'bg-green-50 border-green-200'
                        }`}
                      >
                        <div className="flex-shrink-0">
                          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                            event.type === 'holiday' ? 'bg-red-100 text-red-700' :
                            event.type === 'academic' ? 'bg-blue-100 text-blue-700' :
                            'bg-green-100 text-green-700'
                          }`}>
                            <event.icon className="w-4 h-4" />
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-sm font-bold text-gray-900">{event.date}</span>
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                              event.type === 'holiday' ? 'bg-red-200 text-red-700' :
                              event.type === 'academic' ? 'bg-blue-200 text-blue-700' :
                              'bg-green-200 text-green-700'
                            }`}>
                              {event.type === 'holiday' ? 'Holiday' : 
                               event.type === 'academic' ? 'Academic' : 'Event'}
                            </span>
                          </div>
                          <p className="text-sm font-medium leading-tight text-gray-900">{event.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Important Dates */}
        <div className="p-5 mt-8 border border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl">
          <div className="flex items-center gap-3 mb-4">
            <FaStar className="w-5 h-5 text-blue-600" />
            <h3 className="text-lg font-bold text-gray-900">Key Dates 2026</h3>
          </div>
          
          <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
            {importantDates.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg">
                <div>
                  <p className="text-sm font-medium text-gray-900">{item.title}</p>
                  <p className="text-xs text-gray-600">{item.date}</p>
                </div>
                <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
                  item.type === 'holiday' ? 'bg-red-100 text-red-700' :
                  item.type === 'academic' ? 'bg-blue-100 text-blue-700' :
                  'bg-gray-100 text-gray-700'
                }`}>
                  {item.type === 'holiday' ? 'Holiday' : 
                   item.type === 'academic' ? 'Academic' : 'Info'}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Legend */}
        <div className="p-4 mt-6 bg-white border border-gray-200 rounded-xl">
          <h4 className="mb-3 text-sm font-bold text-gray-900">Event Types</h4>
          <div className="grid grid-cols-3 gap-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-xs text-gray-700">Holidays</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
              <span className="text-xs text-gray-700">Academic</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-xs text-gray-700">Events</span>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="p-4 mt-6 text-center border border-gray-200 bg-gray-50 rounded-xl">
          <p className="text-xs text-gray-600">
            * Dates are tentative and subject to change. Please check school notice board for updates.
          </p>
          <div className="inline-flex items-center gap-2 mt-2 px-3 py-1.5 bg-white border border-gray-300 rounded-full">
            <FaSchool className="w-3 h-3 text-blue-600" />
            <span className="text-xs font-medium text-gray-900">Office: 8 AM - 4 PM</span>
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default Calendar;